import { get } from "http";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_ANOMALY_ACTIVE_REQUEST_LIST,
    REQUEST_ANOMALY_REQUEST_DELETE,
    REQUEST_ANOMALY_HISTORY_LIST,
    REQUEST_ANOMALY_REQUEST_UPDATE,
    REQUEST_ANOMALY_REQUEST_CLEAR,
    REQUEST_ANOMALY_REQUEST_ACKNOWLEDGE,
    REQUEST_ALL_REQUESTS_ACKNOWLEDGED,
    REQUEST_ALL_ANOMALY_ACTIVE_REQUEST_LIST,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/eisenhower/eisenhowerMsgs";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import {
    AnomalyAcknowledge,
    AnomalyRequestHeader,
} from "userful-chronos-app-common-js/dist/models/eisenhower/anomaly/anomaly";
import { HistoryRange } from "userful-chronos-app-common-js/dist/models/eisenhower/history";
import "./anomalyMsgReceiver";

export const requestListAnomalies = (payload: HistoryRange) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ANOMALY_ACTIVE_REQUEST_LIST, payload);
};

export const requestListHistory = (payload: HistoryRange) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ANOMALY_HISTORY_LIST, payload);
};

export const requestAnomalyUpdate = (payload: AnomalyRequestHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ANOMALY_REQUEST_UPDATE, payload);
};
export const requestDeleteAnomaly = (payload: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ANOMALY_REQUEST_DELETE, payload);
};

export const requestClearAllAnomalies = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ANOMALY_REQUEST_CLEAR);
};

export const requestAnomalyAcknowledge = (payload: AnomalyAcknowledge) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ANOMALY_REQUEST_ACKNOWLEDGE, payload);
};

export const requestAcknowlegeAllAnomalies = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ALL_REQUESTS_ACKNOWLEDGED);
};

export const requestListAllAnomalies = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ALL_ANOMALY_ACTIVE_REQUEST_LIST);
};
